import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import SearchFilterTable from '../../microComponents/tablePages/filter/SearchFilterTable';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import SelectFilterTable from '../../microComponents/tablePages/filter/SelectFilterTable';
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import GetProductList from "../Products/GetProductList";
import DateFilterTable from "../../microComponents/tablePages/filter/DateFilterTable";

const BatchHistoryColumn = () => {
    const [getColumnDateProps,] = DateFilterTable()

    const filter = useSelector((state) => state.TableRedux.filter);
    const [getColumnSearchProps] = SearchFilterTable();
    const [filterBranch, setFilterBranch] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);
    const [handleSetParams] = UseSetParams();
    const [getColumnSelectProps] = SelectFilterTable();
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const getProductList = () => {
        GetProductList(setProductList, setProductListLoading)
    }

    const handleGetFilterBranch = () => {

        getFilterBranch(setFilterBranch, setBranchLoading)
    }
    const handleGetFilterProductLine = () => {

        getFilterProductLine(setFilterProductLine, setProductLineLoading)
    }
    const funcHandleSetParams = (newFilter) => {
        handleSetParams(newFilter);
    };


    const columns = [{
        title: 'ردیف', dataIndex: 'row',className: "hidden lg:table-cell", key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },
        {
            title: 'واحد',
            dataIndex: 'branch',
            key: 'branch', ...getColumnSelectProps(filter.branch, 'branch', 'واحد', filterBranch, handleGetFilterBranch, (res) => {
                funcHandleSetParams([{key: 'branch', value: res}]);
            }, branchLoading),
        }, {
            title: 'خط تولید',
            dataIndex: 'productLine',
            key: 'productLine', ...getColumnSelectProps(filter.brand, 'productLine', 'خط تولید', filterProductLine, handleGetFilterProductLine, (res) => {
                funcHandleSetParams([{key: 'productLine', value: res}]);
            }, productLineLoading),


        }, {
            title: 'شماره بچ',
            dataIndex: 'batchNumber',
            key: 'batchNumber',
            ...getColumnSearchProps('شماره بچ', filter.batchNumber, (res) => {
                funcHandleSetParams([{key: 'batchNumber', value: res}]);
            },'batchNumber'),



        },  {
            title: 'محصول',className: "hidden xs:table-cell",
            dataIndex: 'product',
            key: 'product', ...getColumnSelectProps(filter.product, 'product', 'محصول', productList, getProductList, (res) => {

                funcHandleSetParams([{key: 'product', value: res}]);
            }, productListLoading),
        },
        {
            title: '  چاپ شده', dataIndex: 'printedCounter', key: 'printedCounter',className: "hidden 3xs:table-cell",
        },

        {
            title: 'تحویل به انبار', className: "hidden sm:table-cell",dataIndex: 'registredCounter', key: 'registredCounter', render: (item, row) => {
                return <div>{row.totalRgisterdCounter > 0 && (`${row.registredCounter} (${row.totalRgisterdCounter}) `)}</div>

            }
        },


        {
            title: 'ابطال ',className: "hidden sm:table-cell",
            dataIndex: 'cancleCounter',
            key: 'cancleCounter',
        },
        {
            title: 'در حال بررسی',className: "hidden md:table-cell",
            dataIndex: 'quarantineCounter',
            key: 'quarantineCounter',
            render: (item, row) => {
                return <div>{row.totalQuarantineCounter > 0 && (`${row.quarantineCounter} (${row.totalQuarantineCounter}) `)}</div>

            }
        },

        {
            title: 'امحا',className: "hidden 2md:table-cell",
            dataIndex: 'destroyedCounter',
            key: 'destroyedCounter',
            render: (item, row) => {
                // todo test this line
                return <div>{row.totalDestroyedCounter > 0 && (`${row.destroyedCounter} (${row.totalDestroyedCounter}) `)}</div>
            }
        },
        {
            title: 'بازسازی شده',className: "hidden 2md:table-cell",
            dataIndex: 'totalReconstructCounter',
            key: 'totalReconstructCounter',
            render: (item) => {
                return <span>{!!item && item}</span>
            }

        },
        // {
        //     title: 'تعداد در پالت ',className: "hidden lg:table-cell",
        //     dataIndex: 'numberPerPallet',
        //     key: 'numberPerPallet',
        //
        //
        // },

        {
            title: 'کنترل کیفی',className: "hidden lg:table-cell",
            dataIndex: 'qualityControlAdmin',
            key: 'qualityControlAdmin',
            ...getColumnSearchProps('کنترل کیفی', filter.qualityControlAdmin, (res) => {
                funcHandleSetParams([{key: 'qualityControlAdmin', value: res}]);
            },'qualityControlAdmin'),

        }, {
            title: 'تاریخ ثبت',className: "hidden lg:table-cell",
            dataIndex: 'created',
            key: 'created',
            ...getColumnDateProps([filter.FromCreated, filter.ToCreated], (res) => {


                funcHandleSetParams([{key: 'FromCreated', value: res.from_date}, {
                    key: 'ToCreated', value: res.end_date
                }])
            },'ToCreated'),


        },
        {
            title: 'زمان پایان ',className: "hidden lg:table-cell",
            dataIndex: 'stopDate',
            key: 'stopDate',
        },

    ];
    return [columns]
};

export default BatchHistoryColumn;